import React from 'react';
import { Container, Button } from '@mui/material';
import Header from '../components/Header';
import BannerCarousel from '../components/BannerCarousel';
//import Section from './components/Section';
import Player from '../components/Player';
import Post from '../components/Post';
import StaticHtml from '../components/StaticHtml';
import { useNavigate } from 'react-router-dom';

interface PostPageProps {
  number: number; // ex: 1 → 1.html
}


function PostPage({ number }: PostPageProps) {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Container 
        maxWidth='lg'
        // sx={{ padding: 0, margin: 0, }}
        >

        {/* <BannerCarousel /> */}

        {/* Post 목록으로 가는 버튼 생성 */}
        <Button variant="contained" color="primary" onClick={() => navigate('/posts')}>
          Post 목록으로 가기
        </Button>
        <StaticHtml number={number} />
      </Container>
      <Player />
    </>
  );
}

export default PostPage;